import {
  initCurrentUserStateMiddleware,
  checkAccessMiddleware,
  setPageTitleMiddleware,
} from "./middlewares";
import { routes } from "./routes";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(`[BEFORE] Переход: ${from.fullPath} → ${to.fullPath}`);
  console.time(`RouteGuard-${to.fullPath}`);
  next();
});

router.beforeEach(initCurrentUserStateMiddleware);
router.beforeEach(checkAccessMiddleware);
router.beforeEach(setPageTitleMiddleware);

router.afterEach((to, from) => {
  console.timeEnd(`RouteGuard-${to.fullPath}`);
  console.log(`[AFTER] Успешный переход: ${from.fullPath} → ${to.fullPath}`);
});

// Ловим отменённые переходы
router.onError((err) => {
  console.warn("[ROUTER ERROR]", err);
});

export default router;
